export default __webpack_public_path__ + "static/media/reload-icon.c1c24c52.svg";